import { gql } from '@apollo/client';

export const GET_SCHOOL = gql`
  query getSchool($schoolId: Int!) {
    getSchool(schoolId: $schoolId) {
      schoolId
      name
      districtId
      branding {
        logoUrl
        logoAlt
        logoLinkUrl
      }
    }
  }
`;
